import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";

export const useDeleteDataView = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      await apiClient.deleteDataView(undefined, { params: { id } });
    },
    onSuccess: () => {
      successToast({ message: "Data view deleted" });
      void queryClient.invalidateQueries({ queryKey: [{ entity: "DataViews" }] });
    },
    onError: (error) => {
      errorToast({ message: "Failed to delete data view", error });
    },
  });
};
